import moment from 'moment/moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Insurances/renewals'

export default {
  namespaced: true,
  state: {
    loading: false,
    reportData: {
      data: [],
      grandTotals: {
        opens: 0,
        totals: 0,
        offTarget: 0,
        renewed: 0,
        notRenewed: 0,
        renewedRates: 0,
        chartData: {
          series: [],
          categories: [],
          colors: [],
        },
      },
    },
    renewalParams: {
      sdate: `${moment().format('YYYY-MM')}-01`,
      edate: moment().format('YYYY-MM-DD'),
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    reportData(state) {
      return state.reportData
    },
    renewalParams(state) {
      return state.renewalParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_REPORT_DATA(state, data) {
      state.reportData = data
    },
    /* RESET MUTATIONS */
    RESET_REPORT_DATA(state) {
      state.reportData = {
        data: [],
        grandTotals: {
          opens: 0,
          totals: 0,
          offTarget: 0,
          renewed: 0,
          notRenewed: 0,
          renewedRates: 0,
          chartData: {
            series: [],
            categories: [],
            colors: [],
          },
        },
      }
    },
  },
  actions: {
    getReportData({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_REPORT_DATA')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_REPORT_DATA', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
